import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const contractService = {
  get_by_customer_id: async (customer_id, search = "", token) => {
    const response = await https.get(
      `${API_ROUTES.CONTRACT.GET_BY_CUSTOMER_ID}/${customer_id}?search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_by_id: async (id, token) => {
    const response = await https.get(`${API_ROUTES.CONTRACT.GET_BY_ID}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  create: async (customer_id, data, token) => {
    const response = await https.post(
      `${API_ROUTES.CONTRACT.CREATE}/${customer_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },
  request_profile: async (token, contractId, data) => {
    const response = await https.post(
      `${API_ROUTES.CONTRACT.REQUEST_PROFILE}/${contractId}/request`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },
  update: async (customer_id, data, token) => {
    const response = await https.put(
      `${API_ROUTES.CONTRACT.UPDATE}/${customer_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },
  delete: async (id, token) => {
    const response = await https.delete(
      `${API_ROUTES.CONTRACT.GET_BY_ID}/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
